const FinBankCreditScoreResultI18n = {
  topbar: {
    contractScore: 'Contratar Sankhya Score',
    updateQuery: 'Atualizar Consulta',
    downloadReport: 'Baixar Relatório',
    downloadReportLoading: 'Gerando relatório...',
    downloadReportError: 'Não foi possível gerar o relatório. Tente novamente ou entre em contato com o suporte.',
    consultationHistory: 'Histórico de consultas',
  },
  consultationHistory: {
    title: 'Histórico de consultas',
    subtitle: 'Últimas 10 consultas realizadas',
    scoreLabel: 'Score: {{value}}',
    loadMore: 'Mostrar mais consultas',
    alertsUnavailable: 'Alertas e recomendações disponíveis apenas na consulta atual.',
    indicatorsUnavailable: 'Histórico de indicadores operacionais indisponível para esta consulta.',
  },
  unavailable: {
    badge: 'Indisponível',
  },
  panel: {
    creditScore: 'Score de Crédito',
    scoreUnavailableSubtitle: 'Informação indisponível',
    riskAnalysis: 'Análise de risco de negócio',
    creditLimit: 'Limite de crédito',
    creditLimitForPj: 'Limite de crédito para PJ',
    creditLimitForPf: 'Limite de crédito para PF',
    creditLimitSubtitle: 'Sugerido e disponível',
    creditLimitSubtitlePf: 'Sugerido',
    scoreEvolution: 'Evolução do Score (Até últimas 10 consultas)',
    appointmentsSummary: 'Resumo dos apontamentos',
    lastUpdatedAt: 'Última atualização: {{date}}',
  },
  alerts: {
    sectionTitle: 'Alertas e recomendações',
    latePayment: 'As 3 últimas faturas foram pagas com atraso.',
    inactiveCustomer: 'Cliente sem compras há mais de 60 dias.',
    increasingDelinquency: 'Inadimplência aumentou nos 2 últimos meses fechados.',
    creditLimitNearMax: 'Limite próximo ao máximo. Utilização em {{percent}}% do limite aprovado.',
  },
  gauge: {
    scoreAriaLabel: 'Score {{score}} de {{scoreMax}}',
    of: 'de {{scoreMax}}',
    probabilityTitle: 'Probabilidade de inadimplência',
    riskLabel: {
      LOW: 'Risco baixo',
      MEDIUM: 'Risco médio',
      HIGH: 'Risco alto',
    },
    scoreUnavailableTitle: 'Score indisponível',
    scoreUnavailableDescription: 'Esta consulta está sob restrição judicial, por isso não é possível exibir os dados de score nesse momento.',
  },
  risk: {
    cautionLabel: 'Nível de cautela indicado para essa negociação',
    evaluateWithCaution: 'Avaliar com cautela.',
    suggestionTooltip: 'Essa sugestão não dispensa uma análise de todas as informações, sendo decisão e responsabilidade do credor.',
  },
  riskAnalysis: {
    label: {
      PF: {
        LOW: 'Aprovar',
        HIGH: 'Reprovar',
      },
      PJ: {
        LOW: 'Perfil indicado',
        MEDIUM: 'Perfil mediano',
        HIGH: 'Perfil arriscado',
      },
    },
    description: {
      PF: {
        LOW: 'Apresenta baixa inadimplência, bom comportamento de pagamento, sem protestos, ações cíveis ou débitos.',
        HIGH: 'Perfil com score baixo, probabilidade de inadimplência alta ou possui débitos em aberto. Requer uma análise detalhada.',
      },
      PJ: {
        LOW: 'Empresas com esse perfil têm baixo histórico de inadimplência e boa capacidade de pagamento.',
        MEDIUM: 'Empresas com esse perfil podem apresentar débitos abertos e score reduzido, mas possuem boa capacidade de pagamento no momento.',
        HIGH: 'Empresas com esse perfil apresentam alto risco de inadimplência e exigem cautela na negociação.',
      },
    },
    personType: {
      PF: 'Pessoa física',
      PJ: 'Pessoa jurídica',
    },
    unavailable: {
      label: 'Indisponível',
      description: 'Análise de risco de negócio não disponível.',
    },
  },
  probability: {
    label: {
      LOW: 'Baixa',
      MEDIUM: 'Média',
      HIGH: 'Alta',
    },
    description: {
      PF: 'É provável que {{value}}% das pessoas com esse mesmo comportamento, paguem suas contas nos próximos 6 meses.',
      PJ: 'De cada 1000 empresas classificadas nesta classe de score, é provável que na média {{value}} apresente débitos no mercado nos próximos 12 meses.',
    },
    unavailable: {
      noRelevantInfo: 'Não possui informações relevantes para cálculo do score.',
      notClassified: 'Empresa não classificada, pois o modelo não se aplica para este perfil de empresa.',
      scoreUnavailable: 'Score não disponível.',
    },
  },
  limit: {
    suggestedTotal: 'Total sugerido',
    suggestedTotalPf: 'Valor máximo por parcela',
    usagePercent: '{{percent}}% utilizado',
    usageAriaLabel: 'Limite utilizado {{percent}}%',
    available: 'Disponível',
    used: 'Utilizado',
    tooltips: {
      suggestedTotal: 'Valor de crédito sugerido com base na análise de dados de mercado (bureaus).',
      available: 'Valor ainda disponível para uso, considerando o total sugerido, menos o valor já utilizado.',
      used: 'Soma dos valores já comprometidos, considerando títulos de "receitas" em aberto vinculados ao parceiro no ERP.',
    },
  },
  metrics: {
    tooltips: {
      averageTicket: 'Valor médio das vendas realizadas pelo parceiro no ERP',
      defaultRate: 'Percentual de valores em atraso em relação ao total a receber do parceiro no ERP',
      averageSalesPerMonth: 'Quantidade média de vendas mensais do parceiro com base no seu histórico do ERP.',
      averageReceiptTerm: 'Tempo médio de recebimento do parceiro no ERP',
    },
  },
  chart: {
    seriesName: 'Score',
    emptyMessage: 'Histórico insuficiente para traçar a evolução do score.',
  },
  metricCards: {
    averageTicket: {
      label: 'Ticket médio',
      labelPF: 'Valor médio das parcelas',
      helper: 'Últimos 6 meses',
    },
    delinquencyRate: {
      label: 'Inadimplência',
      helper: 'Últimos 6 meses',
    },
    averageMonthlySales: {
      label: 'Média de vendas por mês',
      helper: 'Últimos 6 meses',
    },
    averageDaysToCollect: {
      label: 'Prazo médio de recebimento',
      helper: 'Últimos 6 meses',
      value: '{{days}} dias',
    },
  },
  appointments: {
    status: {
      healthy: 'Saudável',
      attention: 'Atenção',
    },
    debts: {
      title: 'Débitos / Restrições',
      latestDateLabel: 'Data do débito mais recente',
      totalCountLabel: 'Quantidade total de débitos',
      totalValueLabel: 'Valor total dos débitos',
      emptyMessage: 'Nenhum débito encontrado',
      detail: {
        title: 'Débitos e Restrições',
        fields: {
          creditor: 'Nome do negativador',
          amount: 'Valor',
          date: 'Data',
          contract: 'Número do contrato',
          location: 'Local',
          classification: 'Tipo classificação',
        },
      },
    },
    civilActions: {
      title: 'Ações Cíveis',
      latestDateLabel: 'Data da ação mais recente',
      totalCountLabel: 'Total de ações',
      emptyMessage: 'Nenhuma ação encontrada',
      detail: {
        title: 'Ações Cíveis',
        subtitle: 'Até {{count}} mais recentes',
        fields: {
          plaintiff: 'Autor',
          amount: 'Valor',
          action: 'Ação',
          date: 'Data',
          case: 'Processo',
          location: 'Local',
        },
      },
    },
    protests: {
      title: 'Protestos',
      latestDateLabel: 'Data do protesto mais recente',
      totalCountLabel: 'Quantidade total de protestos',
      totalValueLabel: 'Valor total de protestos',
      emptyMessage: 'Nenhum protesto encontrado',
      detail: {
        title: 'Protestos',
        subtitle: 'Até {{count}} mais recentes',
        fields: {
          date: 'Data',
          amount: 'Valor',
          notary: 'Cartório',
          city: 'Cidade',
          state: 'UF',
        },
      },
    },
  },
  details: {
    pageIndicator: '{{current}} de {{total}}',
    emptyMessage: 'Nenhum registro encontrado',
    restrictionMessage: 'Esta consulta está sob restrição judicial, por isso não é possível exibir os dados nesse momento.',
  },
};

export default FinBankCreditScoreResultI18n;
